import { createSlice } from '@reduxjs/toolkit';

export const checkoutSlice = createSlice({
  name: 'checkout',
  initialState: {
    cardholderName: '',
    isSuccess: null,
    stripeNonce: '',
    braintreeNonce: '',
    id: null,
    paymentError: {
      show: false,
      message: '',
    },
    isCardFormShown: false,
    showSuccessPopup: false,
    openPopoverId: null,
    showUpsellGuideSuccessPopup: false,
  },
  reducers: {
    setCardholderName: (state, action) => {
      state.cardholderName = action.payload;
    },
    setRequestResult: (state, action) => {
      const { isSuccess, id } = action.payload;

      state.isSuccess = isSuccess;
      state.id = id;
    },
    setShowPaymentError: (state, action) => {
      const show: boolean | string = action.payload;
      if (typeof show === 'string') {
        state.paymentError = {
          show: true,
          message: show,
        };
      } else {
        state.paymentError = {
          show: show,
          message: '',
        };
      }
    },
    setIfCardFormShown: (state, action) => {
      state.isCardFormShown = action.payload;
    },
    setStripeNonce: (state, action) => {
      state.stripeNonce = action.payload;
    },
    setBraintreeNonce: (state, action) => {
      state.braintreeNonce = action.payload;
    },
    setShowSuccessPopup: (state, action) => {
      state.showSuccessPopup = action.payload;
    },
    setOpenPopoverId: (state, action) => {
      state.openPopoverId = action.payload;
    },
    setShowUpsellGuideSuccessPopup: (state, action) => {
      state.showUpsellGuideSuccessPopup = action.payload;
    },
  },
});

export const {
  setCardholderName,
  setStripeNonce,
  setBraintreeNonce,
  setRequestResult,
  setShowPaymentError,
  setIfCardFormShown,
  setShowSuccessPopup,
  setOpenPopoverId,
  setShowUpsellGuideSuccessPopup,
} = checkoutSlice.actions;

export default checkoutSlice.reducer;
